import { render, staticRenderFns } from "./planSwitchEligible.vue?vue&type=template&id=0d5a5096&"
import script from "./planSwitchEligible.vue?vue&type=script&lang=js&"
export * from "./planSwitchEligible.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/viewclients.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports